import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_ORDER_LINE } from "../order-line.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateOrderLineInput } from "../../../__generated__/globalTypes";
import {
  CreateOrderLineMutation,
  CreateOrderLineMutationVariables,
} from "../../../__generated__/CreateOrderLineMutation";

interface IProps {
  defaultValues: DeepPartial<CreateOrderLineInput>;
  onCompleted: () => any;
}

export const useCreateOrderLine = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateOrderLineInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateOrderLineMutation,
    CreateOrderLineMutationVariables
  >(CREATE_ORDER_LINE, {
    refetchQueries: ["OrderLinesQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createOrderLine?.ok) {
        onCompleted();
      } else {
        throw Error(data?.createOrderLine?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
